import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ShieldCheck, Bot, Clock, Users, ChevronRight } from 'lucide-react';
import '../components/Home.css';

/**
 * HomePage - Landing page with training module CTAs
 */
function HomePage() {
  const { t } = useTranslation();

  return (
    <div className="home-container">
      {/* Hero */}
      <section className="hero-section">
        <div className="hero-content">
          <p className="hero-eyebrow">{t('home.eyebrow')}</p>
          <h1 className="hero-title">{t('home.title')}</h1>
          <p className="hero-subtitle">{t('home.subtitle')}</p>
        </div>
      </section>

      {/* Training Modules */}
      <section className="modules-section">
        <h2 className="modules-heading">{t('home.modulesHeading')}</h2>
        <div className="modules-grid">
          <Link to="/training" className="module-card">
            <div className="module-icon">
              <ShieldCheck size={32} />
            </div>
            <div className="module-body">
              <h3 className="module-title">{t('modules.cybersecurity.title')}</h3>
              <p className="module-description">{t('modules.cybersecurity.description')}</p>
              <div className="module-meta">
                <span className="module-meta-item">
                  <Clock size={14} />
                  {t('modules.cybersecurity.duration')}
                </span>
                <span className="module-meta-item">
                  <Users size={14} />
                  {t('modules.cybersecurity.audience')}
                </span>
              </div>
            </div>
            <ChevronRight size={20} className="module-arrow" />
          </Link>

          <Link to="/ai-training" className="module-card">
            <div className="module-icon">
              <Bot size={32} />
            </div>
            <div className="module-body">
              <h3 className="module-title">{t('modules.aiLiteracy.title')}</h3>
              <p className="module-description">{t('modules.aiLiteracy.description')}</p>
              <div className="module-meta">
                <span className="module-meta-item">
                  <Clock size={14} />
                  {t('modules.aiLiteracy.duration')}
                </span>
                <span className="module-meta-item">
                  <Users size={14} />
                  {t('modules.aiLiteracy.audience')}
                </span>
              </div>
            </div>
            <ChevronRight size={20} className="module-arrow" />
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="home-footer">
        <p className="footer-text">{t('home.footer')}</p>
      </footer>
    </div>
  );
}

export default HomePage;
